import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {SearchesService} from '../../../services/searches/searches.service';
import {CriterionsTypesInterface} from '../../../interfaces/criterions/criterions-types.interface';
import {CriterionInterface} from '../../../interfaces/criterions/criterion.interface';
import {MatListItem} from '@angular/material/list';
import {CriterionItemPanelComponent} from './criterion-item-panel/criterion-item-panel.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipEditedEvent, MatChipInputEvent} from '@angular/material/chips';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {SearchSummaryComponent} from '../../modals/search/search-summary/search-summary.component';
import {ModalController} from '@ionic/angular';
import {GeolocModalComponent} from '../../modals/geoloc-modal/geoloc-modal.component';
import {SearchCreationComponent} from '../search-creation/search-creation.component';
import {MatDialog} from '@angular/material/dialog';
import {FeSearchbarComponent} from '../../parts/fe-searchbar/fe-searchbar.component';
import {UserService} from '../../../services/user/user.service';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  startWith,
  switchMap,
  takeUntil
} from 'rxjs/operators';
import {SessionInterface} from '../../../interfaces/session/session.interface';
import {IconType} from "../../parts/fe-icon/fe-icon.component";
import {CodeApe, SearchDataInterface} from "../../../interfaces/search/search-data.interface";
import {FormControl} from "@angular/forms";
import {combineLatest, of, Subject} from "rxjs";
import {MatExpansionPanel} from "@angular/material/expansion";
import {MatSlider} from "@angular/material/slider";
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {
  MetricsQualifierInterface,
  MetricsTypeInterface,
  QuantitativeDataOperator,
  QuantitativeDataQualifierInterface,
  QuantitativeDataTypeInterface
} from '../../../interfaces/criterions/metrics-type.interface';
import {MetricsUtils} from '../../../classes/MetricsUtils';
import {Utils} from '../../../classes/Utils';
import {FeatureAccessService} from '../../../services/feature-access/feature-access.service';

interface MetricFilter {
  active: boolean;
  indexMin: number;
  indexMax: number;
  includeNull: boolean;
  sliderValues: number[];
}

@Component({
  selector: 'app-search-list-criterions',
  templateUrl: './search-list-criterions.component.html',
  styleUrls: ['./search-list-criterions.component.scss']
})
export class SearchListCriterionsComponent implements OnInit {

  public currentTypeCriterion: string;
  public criterionsTypes: CriterionsTypesInterface;
  public currentCriterions: Array<CriterionInterface> = [];
  public currentFilter: string = '';
  public keywords = {must: [], should: [], mustNot: [], all: []};
  public geoloc: {cityFrom?: number, geolocDistanceRadius?: number, geolocFrom?: string, cityName?: string};
  public entrepriseData: {effectifNull?: boolean, caNull?: boolean, effectifActive?: boolean, caActive?: boolean, effectifMin?: number, effectifMax?: number, chiffreDaffaireMin?: number, chiffreDaffaireMax?: number, codeApes?: Array<CodeApe>} = {codeApes: []};

  public sliderEffectifValues: number[] = [0,5,10,20,50,100,250,500,1000,2000,5000,120000];
  public sliderCaValues: number[] = [0,100,500,1000,5000,10000,50000,100000,500000,1000000,5000000,100000000];

  // Données chiffrées : filtre par qualificatif (clé = id du qualificatif), créé à la première utilisation
  public metricsData: {[qualifierId: number]: MetricFilter} = {};
  // Données chiffrées : opérateur entre les qualificatifs d'un type (clé = id du type), ET si absent
  public metricsOperators: {[typeId: number]: QuantitativeDataOperator} = {};
  // Données chiffrées de la recherche éditée, appliquées à la création des filtres
  private initialQuantitativeData: Array<QuantitativeDataTypeInterface> = [];

  public sliderEffectifIndexMin: number = 0;
  public sliderEffectifIndexMax: number = 11;
  public sliderCaIndexMin: number = 0;
  public sliderCaIndexMax: number = 11;

  @Output() emitter = new EventEmitter();
  @ViewChildren(CriterionItemPanelComponent) criterionItemPanels: QueryList<CriterionItemPanelComponent>;
  @ViewChild(FeSearchbarComponent) searchBar: FeSearchbarComponent;
  @Output() launchTour = new EventEmitter();

  // @ViewChild('inputEffectifMin') inputEffectifMin: ElementRef;
  // @ViewChild('inputEffectifMax') inputEffectifMax: ElementRef;
  @ViewChild('sliderEffectif') sliderEffectif: MatSlider;

  // @ViewChild('inputCaMin') inputCaMin: ElementRef;
  // @ViewChild('inputCaMax') inputCaMax: ElementRef;
  @ViewChild('sliderCa') sliderCa: MatSlider;


  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  public geolocSearchAvailable: boolean;
  public leadsAvailable: boolean;
  private effectifChange$ = new Subject<void>();

  constructor(public searchesService: SearchesService
      , private modalController: ModalController
      , public dialog: MatDialog
      , public userService: UserService
      , private cdr: ChangeDetectorRef
      , private featureAccessService: FeatureAccessService) {
  }

  // Option "données institutionnelles" : texte d'aide sur l'apparition des articles institutionnels
  get hasInstitutionalData(): boolean {
    return this.featureAccessService.hasInstitutionalData();
  }

  public ngOnInit(): void {
    // this.searchesService.getCriterions().pipe().subscribe((criterionsTypes: CriterionsTypesInterface) => {
    //   this.criterionsTypes = criterionsTypes;
    // });

    this.effectifChange$
        .pipe(debounceTime(400))
        .subscribe(() => {
          this.emitter.emit();
        });

    this.userService.getSessionDatas().pipe().subscribe(
            (sessionData: SessionInterface) => {
              if (sessionData !== undefined) {
                sessionData.appConfig.viewConfigs.forEach(value => {
                  if (value.component === 'GEOLOCATION_SEARCH') {
                    if (value.state === 'visible') {
                      this.geolocSearchAvailable = true;
                    }
                  }
                  if (value.component === 'LEADS_TOPICS_CHOICE') {
                    if (value.state === 'visible') {
                      this.leadsAvailable = true;
                    }
                  }
                });
              }
            }
        );
  }

  filterCriterions(value: any) {
    this.currentFilter = value;
    this.searchBar.value = this.currentFilter;
    this.criterionItemPanels.forEach(itemPanel => {
      itemPanel.filter = this.currentFilter;
    });
  }

  selectDeselectAll($event: MatCheckboxChange) {
    for (let criterion of this.currentCriterions) {
      if (!(criterion.subType === 'temporal') && !(criterion.subType === 'predictive')) {
        criterion.checked_ = $event.checked;
        this.selectDeselectAllChildren(criterion.childCriterions, $event.checked);
      }
    }
    this.emitter.emit();
  }

  selectDeselectAllChildren(criterions: Array<CriterionInterface>, check: boolean) {
    for (let criterion of criterions) {
      if (!(criterion.subType === 'temporal') && !(criterion.subType === 'predictive')) {
        criterion.checked_ = check;
        this.selectDeselectAllChildren(criterion.childCriterions, check);
      }
    }
  }

  allChecked() {
    let allSelected = true;
    this.criterionItemPanels.forEach(itemPanel => {
      if (!itemPanel._criterion.checked_) {
        allSelected = false;
        return;
      }
    });
    return allSelected;
  }

  loadCriterions(typeCriterion: any) {
    this.currentFilter = '';
    this.currentTypeCriterion = typeCriterion;
    try {
      this.currentCriterions = this.criterionsTypes[typeCriterion].values;
      if (typeCriterion === 'sourceOrigins') {
        this.currentCriterions = this.currentCriterions.filter(criterion => !this.isHiddenSourceOrigin(criterion));
      }
    } catch (e) {
      // Non renvoyé par l'API pour les clients hors Veille Augmentée
      this.currentCriterions = [];
    }
    if (typeCriterion === 'companySizes') {
      this.cdr.detectChanges();
      this.onCaInput();
      this.onEffectifInput();
    }
  }

  /**
   * Origine de la source : branches non proposées dans la modale (seules les sources institutionnelles le sont)
   */
  private isHiddenSourceOrigin(criterion: CriterionInterface): boolean {
    const label = (criterion.label || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    return label.startsWith('actualites d') || label === 'presse';
  }

  getCriterionTypeTitle() {
    switch (this.currentTypeCriterion) {
      case 'sectors':
        return 'Secteurs d\'activité';
      case 'topics':
        return 'Evénements économiques';
      case 'veilleAugmentee':
        return this.userService.sessionData.customerDetails.companyName;
      case 'locations':
        return 'Localisations';
      case 'companySizes':
        return 'Données d\'entreprise';
      case 'donneesChiffrees':
        return 'Données chiffrées';
      case 'activityTypes':
        return 'Nature des locaux';
      case 'sourceOrigins':
        return 'Origine de la source';
      case 'decisionsAdmin':
        return 'Décisions administratives';
      case 'keywords':
        return 'Mots-clés';
    }

    return '';
  }

  getCriterionTypeSubTitle() {
    switch (this.currentTypeCriterion) {
      case 'sectors':
        return 'Sélection des secteurs d\'activités que vous ciblez';
      case 'topics':
        return 'Événement économique relaté dans l\'article';
      case 'veilleAugmentee':
        return 'Tag de veille augmentée spécifique à votre entreprise';
      case 'locations':
        return 'Sélection des régions, départements ou pays limitrophes que vous ciblez';
      case 'companySizes':
        return 'Sélection des tailles d\'entreprises que vous ciblez';
      case 'activityTypes':
        return 'Nature des locaux de l\'entité concernée';
      case 'sourceOrigins':
        return 'Organisme à l\'origine de la source de l\'article';
      case 'decisionsAdmin':
        return 'Décision administrative relatée dans l\'article';
      case 'keywords':
        return 'Rechercher par mots clés ou expressions';
    }

    return '';
  }

  getCriterions() {
    return this.criterionsTypes;
  }

  getKeywords() {
    this.keywords.all = [...this.keywords.must, ...this.keywords.should];
    return this.keywords;
  }

  initCriterions(criterionsTypes: CriterionsTypesInterface) {
    this.criterionsTypes = criterionsTypes;
  }

  changeCriterionSelection() {
    this.emitter.emit();
  }

  isCriterionType() {
    return this.currentTypeCriterion === 'sectors' || this.currentTypeCriterion === 'topics' || this.currentTypeCriterion === 'veilleAugmentee' || this.currentTypeCriterion === 'locations' || this.currentTypeCriterion === 'companySizes' || this.currentTypeCriterion === 'activityTypes' || this.currentTypeCriterion === 'sourceOrigins' || this.currentTypeCriterion === 'decisionsAdmin';
  }

  add(event: MatChipInputEvent, type: string): void {
    const value = (event.value || '').trim();

    if (value && type === 'must') {
      this.keywords.must.push(value);
    }
    else if (value && type === 'should') {
      this.keywords.should.push(value);
    }
    else if (value && type === 'mustNot') {
      this.keywords.mustNot.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();
    this.emitter.emit();
  }

  remove(value: string, type: string): void {
    if (value && type === 'must') {
      const index = this.keywords.must.indexOf(value);
      if (index >= 0) {
        this.keywords.must.splice(index, 1);
      }
    }
    else if (value && type === 'should') {
      const index = this.keywords.should.indexOf(value);
      if (index >= 0) {
        this.keywords.should.splice(index, 1);
      }
    }
    else if (value && type === 'mustNot') {
      const index = this.keywords.mustNot.indexOf(value);
      if (index >= 0) {
        this.keywords.mustNot.splice(index, 1);
      }
    }
    this.emitter.emit();
  }

  edit(keyword: string, event: MatChipEditedEvent, type: string) {
    const value = event.value.trim();

    if (!value) {
      this.remove(keyword, type);
      return;
    }

    if (type === 'must') {
      const index = this.keywords.must.indexOf(keyword);
      if (index >= 0) {
        this.keywords.must[index] = value;
      }
    }
    else if (type === 'should') {
      const index = this.keywords.should.indexOf(keyword);
      if (index >= 0) {
        this.keywords.should[index] = value;
      }
    }
    else if (type === 'mustNot') {
      const index = this.keywords.mustNot.indexOf(keyword);
      if (index >= 0) {
        this.keywords.mustNot[index] = value;
      }
    }
    this.emitter.emit();
  }

  initKeywordToEdit(param: { mustNot: any; should: any; must: any; all: any; }) {
    this.keywords = param;
  }

  async openGeoloc() {
    const dial = this.dialog.open(GeolocModalComponent, {
      height: '310px',
      width: '600px',
      data: {geoloc: this.geoloc}
    });
    dial.afterClosed().subscribe(value => {
      if (value) {
        this.geoloc =  {
          cityFrom: value.city.id,
          geolocFrom: '',
          geolocDistanceRadius: value.rayon,
          cityName: value.city.name + ' (' + value.city.zip + ')'
        };
        this.emitter.emit();
      }
    });
  }

  initGeoloc(geoloc: any) {
    this.geoloc = geoloc;
  }

  removeGeoloc() {
    this.geoloc =  null;
    this.emitter.emit();
  }

  protected launchTemporalTour(): void {
    let tourToEmmit = 'topic_temporal_or_leads';
    if (!this.leadsAvailable) {
      tourToEmmit = 'discover_topic_temporal_or_leads';
    }
    this.launchTour.emit(tourToEmmit);
  }

  protected readonly IconType = IconType;

  protected getGuideLeadBtnText(): string {
    if (this.leadsAvailable) {
      return 'Guide sur l\'utilisation des temporalités et des leads prédictifs';
    } else {
      return 'Découvrir les temporalités et les leads prédictifs';
    }
  }

  initEntrepriseData(data: SearchDataInterface) {
    if (data) {
      if (data.effectifs) {
        this.entrepriseData.effectifActive = true;
        this.entrepriseData.effectifMin = Number(data.effectifs.split(';')[0]);
        this.entrepriseData.effectifMax = Number(data.effectifs.split(';')[1]);

        this.sliderEffectifIndexMin = this.sliderEffectifValues.indexOf(this.entrepriseData.effectifMin);
        this.sliderEffectifIndexMax = this.sliderEffectifValues.indexOf(this.entrepriseData.effectifMax);

        if (this.sliderEffectifIndexMin === -1) {
          this.sliderEffectifIndexMin = 0;
        }
        if (this.sliderEffectifIndexMax === -1) {
          this.sliderEffectifIndexMax = 11;
        }

      } else {
        this.entrepriseData.effectifMin = 0;
        this.entrepriseData.effectifMax = 120000;
      }
      if (data.chiffreDaffaire) {
        this.entrepriseData.caActive = true;
        this.entrepriseData.chiffreDaffaireMin = Number(data.chiffreDaffaire.split(';')[0]);
        this.entrepriseData.chiffreDaffaireMax = Number(data.chiffreDaffaire.split(';')[1]);

        this.sliderCaIndexMin = this.sliderCaValues.indexOf(this.entrepriseData.chiffreDaffaireMin);
        this.sliderCaIndexMax = this.sliderCaValues.indexOf(this.entrepriseData.chiffreDaffaireMax);

        if (this.sliderCaIndexMin === -1) {
          this.sliderCaIndexMin = 0;
        }
        if (this.sliderCaIndexMax === -1) {
          this.sliderCaIndexMax = 11;
        }
      } else {
        this.entrepriseData.chiffreDaffaireMin = 0;
        this.entrepriseData.chiffreDaffaireMax = 100000;
      }
      if (data.codeApesLabels) {
        this.entrepriseData.codeApes = data.codeApesLabels;
      }
      this.entrepriseData.caNull = data.caNull;
      this.entrepriseData.effectifNull = data.effectifsNull;
    } else {
      this.entrepriseData.effectifMin = 0;
      this.entrepriseData.effectifMax = 120000;
      this.entrepriseData.chiffreDaffaireMin = 0;
      this.entrepriseData.chiffreDaffaireMax = 100000;
    }
  }


  initMetricsData(data: SearchDataInterface) {
    this.metricsData = {};
    this.initialQuantitativeData = data?.quantitativeData || [];
    this.metricsOperators = {};
    for (const type of this.initialQuantitativeData) {
      this.metricsOperators[type.typeId] = MetricsUtils.operator(type);
    }
  }

  /**
   * Nombre de qualificatifs cochés dans un type
   */
  getActiveMetricsCount(metricsType: MetricsTypeInterface): number {
    return (metricsType.qualifiers || []).filter(qualifier => this.getMetricFilter(qualifier).active).length;
  }

  getMetricsOperator(metricsType: MetricsTypeInterface): QuantitativeDataOperator {
    return this.metricsOperators[metricsType.id] === 'or' ? 'or' : 'and';
  }

  setMetricsOperator(metricsType: MetricsTypeInterface, operator: QuantitativeDataOperator) {
    if (this.getMetricsOperator(metricsType) === operator) {
      return;
    }
    this.metricsOperators[metricsType.id] = operator;
    this.onMetricChange();
  }

  /**
   * Un type précédent (dans l'ordre d'affichage) a au moins un qualificatif coché : séparateur ET avant ce type
   */
  hasPreviousActiveMetricsType(index: number): boolean {
    return this.getMetricsTypes().slice(0, index).some(metricsType => this.getActiveMetricsCount(metricsType) > 0);
  }

  /**
   * Phrase expliquant le résultat des filtres cochés d'un type
   */
  getMetricsTypeSentence(metricsType: MetricsTypeInterface): string {
    const type = this.getQuantitativeData().find(t => t.typeId === metricsType.id);
    return type ? MetricsUtils.sentence(this.getMetricsTypes(), type) : '';
  }

  getMetricsTypes(): Array<MetricsTypeInterface> {
    return this.criterionsTypes?.metrics || [];
  }

  getMetricFilter(qualifier: MetricsQualifierInterface): MetricFilter {
    let metricFilter = this.metricsData[qualifier.id];
    if (!metricFilter) {
      const sliderValues = MetricsUtils.getSliderValues(qualifier.units);
      metricFilter = {
        active: false,
        indexMin: 0,
        indexMax: sliderValues.length - 1,
        includeNull: false,
        sliderValues
      };
      const initialQualifier = MetricsUtils.findSelectedQualifier(this.initialQuantitativeData, qualifier.id);
      if (initialQualifier) {
        metricFilter.active = true;
        metricFilter.includeNull = !!initialQualifier.includeNull;
        // Borne absente = slider en butée ; sinon palier le plus proche englobant la borne enregistrée
        if (initialQualifier.min !== null && initialQualifier.min !== undefined) {
          metricFilter.indexMin = Math.max(sliderValues.filter(value => value <= initialQualifier.min).length - 1, 0);
        }
        if (initialQualifier.max !== null && initialQualifier.max !== undefined) {
          const indexMax = sliderValues.findIndex(value => value >= initialQualifier.max);
          metricFilter.indexMax = indexMax === -1 ? sliderValues.length - 1 : indexMax;
        }
      }
      this.metricsData[qualifier.id] = metricFilter;
    }
    return metricFilter;
  }

  formatMetricValue(qualifier: MetricsQualifierInterface, index: number): string {
    const metricFilter = this.getMetricFilter(qualifier);
    const value = MetricsUtils.formatValue(metricFilter.sliderValues[index], qualifier.units);
    return index === metricFilter.sliderValues.length - 1 ? value + ' et +' : value;
  }

  onMetricChange() {
    this.effectifChange$.next();
  }

  /**
   * Données chiffrées sélectionnées, au format JSON enregistré dans la recherche (quantitativeData) :
   * regroupées par type avec leur opérateur (ET si moins de 2 qualificatifs), slider en butée = borne absente
   */
  getQuantitativeData(): Array<QuantitativeDataTypeInterface> {
    if (this.getMetricsTypes().length === 0) {
      // Référentiel non chargé : on conserve les données chiffrées de la recherche éditée
      return Utils.deepCopy(this.initialQuantitativeData);
    }
    const quantitativeData: Array<QuantitativeDataTypeInterface> = [];
    for (const type of this.getMetricsTypes()) {
      const qualifiers: Array<QuantitativeDataQualifierInterface> = [];
      for (const qualifier of type.qualifiers || []) {
        const metricFilter = this.getMetricFilter(qualifier);
        if (metricFilter.active) {
          const lastIndex = metricFilter.sliderValues.length - 1;
          qualifiers.push({
            qualifierId: qualifier.id,
            min: metricFilter.indexMin > 0 ? metricFilter.sliderValues[metricFilter.indexMin] : undefined,
            max: metricFilter.indexMax < lastIndex ? metricFilter.sliderValues[metricFilter.indexMax] : undefined,
            includeNull: metricFilter.includeNull
          });
        }
      }
      if (qualifiers.length > 0) {
        quantitativeData.push({typeId: type.id, operator: qualifiers.length > 1 ? this.getMetricsOperator(type) : 'and', qualifiers});
      }
    }
    return quantitativeData;
  }

  inputCtrl = new FormControl<string>('', { nonNullable: true });

  // suggestions$ = this.inputCtrl.valueChanges.pipe(
  //     debounceTime(300),
  //     distinctUntilChanged(),
  //     filter(term => term.length >= 2),
  //     switchMap(term =>
  //         this.searchesService.autocompleteCodeApe(term).pipe(
  //             map(items => items.filter(item => !this.isSelected(item))),
  //             catchError(() => of([]))
  //         )
  //     )
  // );

  selectionChanged$ = new Subject<void>();

  suggestions$ = combineLatest([
    this.inputCtrl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(term => term?.length >= 2),
        switchMap(term =>
            this.searchesService.autocompleteCodeApe(term).pipe(
                catchError(() => of([]))
            )
        )
    ),
    this.selectionChanged$.pipe(startWith(void 0))
  ]).pipe(
      map(([items]) => items.filter(item => !this.isSelected(item)))
  );

  select(option: CodeApe, input: HTMLInputElement, trigger: MatAutocompleteTrigger) {
    if (!this.isSelected(option)) {
      this.entrepriseData.codeApes.push(option);
    }

    this.selectionChanged$.next();

    input.value = '';
    this.inputCtrl.setValue('');
    this.emitter.emit();

    setTimeout(() => {
      input.focus();
      trigger.openPanel();
    });
  }

  removeApe(option: CodeApe) {
    this.entrepriseData.codeApes = this.entrepriseData.codeApes.filter(x => x.code !== option.code);
    this.emitter.emit();
  }

  isSelected(option: CodeApe): boolean {
    return this.entrepriseData.codeApes.some(x => x.code === option.code);
  }

  onEffectifChange() {
    this.entrepriseData.effectifMin = this.sliderEffectifValues[this.sliderEffectifIndexMin];
    this.entrepriseData.effectifMax = this.sliderEffectifValues[this.sliderEffectifIndexMax];
    this.entrepriseData.chiffreDaffaireMin = this.sliderCaValues[this.sliderCaIndexMin];
    this.entrepriseData.chiffreDaffaireMax = this.sliderCaValues[this.sliderCaIndexMax];

    this.effectifChange$.next();
  }

  onEffectifCheck() {
    if (this.entrepriseData.effectifActive) {
      // this.inputEffectifMin.nativeElement.disabled = false;
      // this.inputEffectifMax.nativeElement.disabled = false;
      this.sliderEffectif.disabled = false;
    } else {
      // this.inputEffectifMin.nativeElement.disabled = true;
      // this.inputEffectifMax.nativeElement.disabled = true;
      this.sliderEffectif.disabled = true;
    }
  }

  onCaCheck() {
    if (this.entrepriseData.caActive) {
      // this.inputCaMin.nativeElement.disabled = false;
      // this.inputCaMax.nativeElement.disabled = false;
      this.sliderCa.disabled = false;
    } else {
      // this.inputCaMin.nativeElement.disabled = true;
      // this.inputCaMax.nativeElement.disabled = true;
      this.sliderCa.disabled = true;
    }
  }

  onEffectifInput() {
    // if (this.entrepriseData.effectifMin >= 0) {
    //   this.sliderEffectif.min = this.entrepriseData.effectifMin;
    // } else {
    //   this.entrepriseData.effectifMin = 0;
    //   this.sliderEffectif.min = 0;
    // }
    //
    // if (this.entrepriseData.effectifMax <= 120000) {
    //   this.sliderEffectif.max = this.entrepriseData.effectifMax;
    // } else {
    //   this.entrepriseData.effectifMax = 120000;
    //   this.sliderEffectif.min = 120000;
    // }
    //
    // this.onEffectifChange();
  }

  onCaInput() {
    // if (this.entrepriseData.chiffreDaffaireMin >= 0) {
    //   this.sliderCa.min = this.entrepriseData.chiffreDaffaireMin;
    // } else {
    //   this.entrepriseData.chiffreDaffaireMin = 0;
    //   this.sliderCa.min = 0;
    // }
    //
    // if (this.entrepriseData.chiffreDaffaireMax <= 100000) {
    //   this.sliderCa.max = this.entrepriseData.chiffreDaffaireMax;
    // } else {
    //   this.entrepriseData.chiffreDaffaireMax = 100000;
    //   this.sliderCa.min = 100000;
    // }
    //
    // this.onEffectifChange();
  }

  formatNumber(value: number): string {
    return new Intl.NumberFormat('fr-FR').format(value);
  }

  caFormat(cab: number) {
    const ca = Number(cab);
    if (ca < 1000) {
      return ca + 'K€';
    }
    if (ca >= 1000 && ca < 1000000) {
      return (ca/1000) + 'M€';
    }
    if (ca >= 1000000) {
      return (ca/1000000) + 'Mds€';
    }

    return ca;
  }
}
